import { render, staticRenderFns } from "./GuestMealSelector.vue?vue&type=template&id=1dabdf33"
import script from "./GuestMealSelector.vue?vue&type=script&lang=js"
export * from "./GuestMealSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports